import { jsxs as v, jsx as l } from "react/jsx-runtime";
import { E as d, S as p } from "./icons.types-0722eef5.js";
function g({ title: o, titleId: r, size: h, width: n, height: s, extended: c = !1, ...e }) {
  const i = c ? d : p, a = h ? i[h] : n || i[c ? "s" : "l"], t = h ? i[h] : s || i[c ? "s" : "l"];
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: a,
      height: t,
      "aria-labelledby": r,
      ...e,
      children: [
        o ? /* @__PURE__ */ l("title", { id: r, children: o }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#FPO_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 0c19.882 0 36 16.118 36 36S55.882 72 36 72 0 55.882 0 36 16.118 0 36 0Zm0 3.6C18.106 3.6 3.6 18.106 3.6 36S18.106 68.4 36 68.4 68.4 53.894 68.4 36 53.894 3.6 36 3.6Zm17.924 40.774a8.196 8.196 0 0 1-3.942.993 8.073 8.073 0 0 1-3.92-.993c-1.217-.663-2.196-1.624-2.938-2.884-.741-1.26-1.112-2.725-1.112-4.396 0-1.699.37-3.175 1.112-4.428.742-1.252 1.721-2.21 2.938-2.872a8.073 8.073 0 0 1 3.92-.994c1.397 0 2.711.331 3.942.994 1.232.662 2.222 1.62 2.97 2.872.75 1.253 1.124 2.73 1.124 4.428 0 1.67-.375 3.136-1.124 4.396-.748 1.26-1.738 2.221-2.97 2.884ZM18.62 38.11v6.955H16.2V29.102h9.072v2.204h-6.653v4.622h6.35v2.182h-6.35Zm12.463 1.036v5.919h-2.419V29.102h5.12c1.223 0 2.282.198 3.175.594.892.396 1.58.969 2.062 1.718.483.748.724 1.641.724 2.678 0 1.67-.547 2.93-1.642 3.78-1.094.85-2.65 1.274-4.665 1.274h-2.355Zm2.355-2.16h-2.355v-5.68h2.636c2.347 0 3.52.928 3.52 2.786 0 .994-.313 1.724-.94 2.192-.626.468-1.58.702-2.861.702Zm16.545 6.027c-.979 0-1.886-.234-2.721-.702-.835-.468-1.501-1.149-1.998-2.041-.497-.893-.745-1.952-.745-3.176 0-1.238.248-2.307.745-3.207.497-.9 1.163-1.584 1.998-2.052a5.475 5.475 0 0 1 2.721-.702c.98 0 1.89.234 2.733.702.842.468 1.519 1.152 2.03 2.052.511.9.767 1.969.767 3.207 0 1.224-.256 2.283-.767 3.176-.511.892-1.188 1.573-2.03 2.04a5.535 5.535 0 0 1-2.733.703Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "FPO_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  g as Fpo
};
